import { Link } from "react-router-dom";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import { Button, Col, Label } from "reactstrap";
import SkorHeader from "../components/SkorHeader";
import RekapNilaiIndividu from "../components/RekapNilaiIndividu";
import getEmailRekapIndividu from "../services/getEmailRekapIndividu";
import useAxios from "../../../Utils/useAxios";
import { useEffect, useState } from "react";
import getAsesmenIndividu from "../services/getAsesmenIndividu";
import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";
import getPredikatNilaiIndividu from "../services/getPredikatNilaiIndividu";
import getStaffByAtasan from "../services/getStaffByAtasan";
import getStaff from "../services/getUser";
import getUnitKerja from "../services/getUnitKerja";
import LIST_DIVISI from "../constants/ListDivisi";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";

const RekapIndividuContain = () => {
  const axiosInstance = useAxios();
  const [data, setData] = useState({ asesmen: [], predikat: [], staf: [] });
  const role = localStorage.getItem("role");
  const [options, setOptions] = useState([]);

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      rekapIndividu();
      refreshStaf();
      refreshPredikat();
      if (role === "Admin") {
        unitKerja();
      }
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  console.log(data.asesmen);

  const unitKerja = () => {
    getUnitKerja(axiosInstance).then((res) => {
      const option = res.data
        .filter((unitKerja) => LIST_DIVISI?.includes(unitKerja.nama_unit_kerja))
        .map((item) => ({
          id: item.id_unit_kerja,
          name: item.nama_unit_kerja,
        }));
      setOptions(option);
    });
  };

  const rekapIndividu = () => {
    getAsesmenIndividu(axiosInstance).then((res) => {
      setData((prev) => ({ ...prev, asesmen: res.data }));
    });
  };

  const refreshStaf = () => {
    if (role === "Atasan") {
      getStaffByAtasan(axiosInstance).then((res) => {
        setData((prev) => ({ ...prev, staf: res.data }));
      });
    } else if (role === "Admin") {
      getStaff(axiosInstance).then((res) => {
        setData((prev) => ({ ...prev, staf: res.data }));
      });
    }
  };

  const refreshPredikat = () => {
    getPredikatNilaiIndividu(axiosInstance).then((res) => {
      setData((prev) => ({ ...prev, predikat: res.data }));
    });
  };

  const sendEmail = () => {
    getEmailRekapIndividu(axiosInstance).then((res) => {
      toast.success(`GET Email Rekap Individu success`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    });
  };

  return (
    <FeatureContainer>
      <div className="d-flex justify-content-between px-4">
        <Link to={`/dashboard/`}>
          <Button>Kembali ke Dashboard</Button>
        </Link>
        {role === "Atasan" && FEATURE_FUNCTION_SELECTION.SendEmail.Send && (
          <Button onClick={sendEmail}>Kirim ke Email</Button>
        )}
      </div>
      <Col
        sm={{
          offset: 1,
          size: 10,
        }}
      >
        <Label className={"d-flex justify-content-center h4"}>
          <strong>Rekap Penilaian Kinerja Individu</strong>
        </Label>
        <SkorHeader className={"py-4 w-75 mx-auto"} predikat={data.predikat} />
        <RekapNilaiIndividu data={data} options={options} />
      </Col>
    </FeatureContainer>
  );
};

export default RekapIndividuContain;
